import { createSelector } from "@reduxjs/toolkit";
import { Project } from "../../entities/project";
import { mapToArray } from "../../helpers";
import { AppState } from "../appState";

const selectProjects = (state: AppState) =>
  state.kronosState.projectState.projects;
const selectProjectFormOpen = (state: AppState) =>
  state.kronosState.projectState.projectFormOpen;
const selectProjectSearchMetadata = (state: AppState) =>
  state.kronosState.projectState.searchMetadata;
const selectProjectFilters = (state: AppState) =>
  state.kronosState.projectState.filters;
const selectProjectSearchOpen = (state: AppState) =>
  state.kronosState.projectState.searchOpen;
const selectSelectedProjectID = (state: AppState) =>
  state.kronosState.projectState.selectedProjectID;
const selectStageProjectSelector = (state: AppState) =>
  state.kronosState.projectState.stagedProject;
const selectProjectLoading = (state: AppState) =>
  state.kronosState.projectState.loading;

export const projectFormOpenSelector = createSelector(
  [selectProjectFormOpen],
  (s) => s
);

export const projectLoadingSelector = createSelector(
  [selectProjectLoading],
  (s) => s
);

export const projectsSelector = createSelector([selectProjects], (projects) =>
  mapToArray(projects).sort((a, b) => b.id - a.id)
);

export const selectedProjectSelector = createSelector(
  [selectProjects, selectSelectedProjectID],
  (projects, selectedProjectID) => {
    if (selectedProjectID) return projects[selectedProjectID];
    return undefined;
  }
);

export const stagedProjectSelector = createSelector(
  [selectStageProjectSelector],
  (s) => (s ? new Project(s) : s)
);

export const selectedProjectIDSelector = createSelector(
  [selectSelectedProjectID],
  (s) => s
);

export const projectSearchOpenSelector = createSelector(
  [selectProjectSearchOpen],
  (s) => s
);

export const projectSearchMetadataSelector = createSelector(
  [selectProjectSearchMetadata],
  (s) => s
);

export const projectFiltersSelector = createSelector(
  [selectProjectFilters],
  (s) => s
);

export const projectSelector = (id?: number) => {
  return createSelector([selectProjects], (projects) => {
    if (id) return projects[id];
    return undefined;
  });
};
